var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRokuLogo = function SvgRokuLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 12,
    viewBox: "0 0 35 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5983_28082)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5983_28082",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -3,
    width: 38,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.986816 15.3535H36.8129V-2.49459H-0.986816V15.3535Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5983_28082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.45825 4.49185C7.45825 3.62101 6.76063 2.9197 5.9076 2.9197H5.13862V6.05008H5.9076C6.76063 6.05008 7.45825 5.34831 7.45825 4.49185ZM10.9563 10.7324H8.13348L5.89236 7.609H5.13862V10.7257H2.65088V1.3624H6.21473C8.26926 1.3624 9.94623 2.76548 9.94623 4.49185C9.94623 5.54474 9.30334 6.48515 8.32491 7.06053L10.9563 10.7324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7621 5.05423C13.1051 5.05423 12.5463 5.95104 12.5463 7.06121C12.5463 8.17138 13.1051 9.06936 13.7621 9.06936C14.4343 9.06936 14.9922 8.17138 14.9922 7.06121C14.9922 5.95104 14.4343 5.05423 13.7621 5.05423ZM17.5913 7.06121C17.5913 9.18207 15.8739 10.8804 13.7621 10.8804C11.651 10.8804 9.94629 9.18207 9.94629 7.06121C9.94629 4.94198 11.651 3.24275 13.7621 3.24275C15.8739 3.24275 17.5913 4.94198 17.5913 7.06121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4292 3.39813L20.5635 6.27572V3.38862H18.0762V10.7261H20.5635V7.74976L23.5553 10.7261H26.6859L22.884 6.90745L26.0331 3.746V8.10042C26.0331 9.54617 26.8989 10.8804 29.079 10.8804C30.114 10.8804 31.0638 10.2908 31.5254 9.75744L32.6438 10.7261H33.1747V3.39813H30.6874V7.2159V8.14263C30.4073 8.63359 30.017 8.94227 29.4138 8.94227C28.8019 8.94227 28.5211 8.57793 28.5211 7.41256V7.10504V3.39813H23.4292Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5983_28082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.0391,
    height: 10.6372,
    fill: "white",
    transform: "translate(0.893066 0.76709)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRokuLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/roku-logo.a16b249ef3af8c2b4854e784c30866db.svg";